<template>
  <section>
    <AboutTeamHeader />
    <AboutTeamIntro />
    <AboutTeamIndex />
    <AboutTeamIndexMore />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'AboutTeam',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages['about-team'] || {}
    }
  }
}
</script>
